import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from './components/ErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals((metric) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }
  void import('./services/ApiService').then(({ default: apiService }) => {
    void apiService.trackEvent('web_vital', {
      metadata: {
        name: metric.name,
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        id: metric.id,
        rating: (metric as { rating?: string }).rating,
        navigationType: (metric as { navigationType?: string }).navigationType,
      },
    });
  });
});
